'use es6';

import dispatcher from 'dispatcher/dispatcher';
import { defineLazyValueStore } from '../store/LazyValueStore';
import { CALLING_ADMIN_SETTINGS } from '../actions/ActionNamespaces';
import { getCallingAdminSettings } from './CallingAdminSettingsAPI';
export default defineLazyValueStore({
  fetch: () => getCallingAdminSettings(),
  namespace: CALLING_ADMIN_SETTINGS
}).defineName('CallingAdminSettingsStore').register(dispatcher);